import { useState, useMemo } from "react";
import { TextareaAutosize, Grid, Button } from "@mui/material";
import { toast } from "react-toastify";
import SurveyService from "../Services/SurveyService";
import { useTranslation } from "react-i18next";
import QuestionModel from "../Models/Survey/Questions/QuestionModel";

export default function TextAnswers(props: {
  questionModel: QuestionModel;
  surveyId: string;
  setQuestionModel: Function;
  setIsFirstQuestion: Function;
  setCurrentQuestionId: Function;
  setLoading: Function;
}) {
  const { t, i18n } = useTranslation("survey");

  const surveyService = useMemo(() => new SurveyService(), []);
  const [textAreaValue, setTextAreaValue] = useState<string>();

  if (props.questionModel !== undefined) {
    return (
      <>
        <TextareaAutosize
          minRows={6}
          style={{ width: "100%", maxWidth: 600 }}
          onChange={(t) => setTextAreaValue(t.target.value)}
        />

        <Grid justifyContent="center" container p={3}>
          <Button
            className="float-start"
            variant="contained"
            key={props.questionModel.id}
            style={{
              textTransform: "none",
              maxWidth: "100%",
            }}
            onClick={() => clickAnswer()}
          >
            {t("Volgende vraag")}
          </Button>
        </Grid>

        {props.questionModel.imageBase64String && (
          <img
            src={`data:${props.questionModel.imageType};base64,${props.questionModel.imageBase64String}`}
            alt="Vraag afbeelding"
            style={{
              marginTop: "1rem",
              maxWidth: "100%",
              maxHeight: "350px",
              height: "auto",
              display: "block",
            }}
          />
        )}
      </>
    );
  }

  return <></>;

  function clickAnswer() {
    if (props.questionModel) {
      props.setLoading(true);

      surveyService
        .saveAnswer(
          {
            surveyId: props.surveyId,
            questionId: props.questionModel.id,
            answer: textAreaValue ?? "",
            nextQuestionId: null,
            possibleAnswerId: null,
          },
          i18n.language,
        )
        .then((result) => {
          if (result) {
            if (result.success) {
              //do stuff with question
              if (result.nextQuestionModel !== null) {
                //set Progress bar
                props.setQuestionModel(result.nextQuestionModel);
                props.setIsFirstQuestion(
                  result.nextQuestionModel.thisIsTheFirstQuestion,
                );
                props.setCurrentQuestionId(result.nextQuestionModel.id);
              }
            } else {
              toast.error(t("Fout bij opslaan van vraag."));
            }
          }
          props.setLoading(false);
        });
    }
  }
}
